import ScreeningTable from './ScreeningTable';

export default ScreeningTable;
